// src/pages/RepayLoan.js

import React from 'react';
import './repay-loan.css';

// import iciciQr from '../assets/images/icici-bank-logo.png';
import kotakLogo from '../assets/images/kotak.png';        

const banks = [
  {
    name: 'Kotak Mahindra Bank',
    logo: kotakLogo,
    // qr: iciciQr,
    // upi: 'dhanwalle@icici',
    accountName: 'Singh Finlease Private Limited.',
    accountNumber: '6345126849',
    ifsc: 'KKBK0000182',
    branch: 'New Delhi - Vasant Vihar',
    accountType: 'Current Account',
  },
  
];

const RepayLoan = () => {
  return (
    <div className="repay-loan-page">
      {/* Hero Section */}
      <section className="repay-hero-section text-white text-center py-3">
        <div className="container">
          <h1 className="fw-bold">Repay Your Loan</h1>
          <p className="lead mt-3 repay-subtitle">Choose your preferred bank and make hassle-free repayments.</p>
        </div>
      </section>

      {/* Bank Cards */}
      <section className="mt-5 bg-light">
        <div className="container">
          {banks.map((bank, index) => (
            <div key={index} className="row align-items-center repay-card mb-5 p-4 shadow rounded-4 bg-white">
              <div className="col-md-7 mb-4 mb-md-0">
                {/* Bank Logo */}
                <div className="text-center mb-3">
                  <img src={bank.logo} alt={`${bank.name} logo`} className="bank-logo mb-2" style={{ height: '60px' }} />
                </div>
                <h4 className="fw-bold text-primary">Bank Details</h4>
                <div className="bank-details ps-md-3">
                  <p><strong>Bank Name:</strong> {bank.name}</p>
                  <p><strong>Company Name:</strong> {bank.accountName}</p>
                  <p><strong>Account No.:</strong> {bank.accountNumber}</p>
                  <p><strong>IFSC Code:</strong> {bank.ifsc}</p>
                  <p><strong>Branch Name:</strong> {bank.branch}</p>
                  <p><strong>Account Type:</strong> {bank.accountType}</p>
                </div>
              </div>

              <div className="col-md-5 text-center">
                <h4 className="fw-bold text-primary">QR Code / UPI</h4>
                <p className="fw-semibold">SCAN & PAY</p>
                <img src={bank.qr} alt="QR Code" className="qr-image mb-3" style={{ width: '260px', borderRadius: '10px' }} />
                <p className="mb-0"><strong>UPI ID:</strong> {bank.upi}</p>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default RepayLoan;
